"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxWrap = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var clsx_1 = tslib_1.__importDefault(require("clsx"));
var styles_1 = require("@material-ui/core/styles");
var Checkbox_1 = tslib_1.__importDefault(require("@material-ui/core/Checkbox"));
var useStyles = styles_1.makeStyles(function (theme) { return ({
    root: {
        "&:hover": {
            backgroundColor: "rgba(0,0,0,0)",
        },
    },
    icon: {
        borderRadius: 3,
        width: 24,
        height: 24,
        boxShadow: "inset 0 0 0 1px " + theme.app.Setting.color,
        "input:disabled ~ &": {
            boxShadow: "none",
            background: "rgba(206,217,224,.5)",
        },
    },
    checkedIcon: {
        backgroundColor: "rgb(115,139,216)",
        boxShadow: "inset 0 0 0 1px rgb(115,139,216)",
        "&:before": {
            display: "block",
            width: 24,
            height: 24,
            backgroundImage: "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
                " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
                "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
            content: '""',
        },
    },
}); });
function CheckboxWrap(props) {
    var classes = useStyles();
    return (react_1.default.createElement(Checkbox_1.default, tslib_1.__assign({ className: classes.root, disableRipple: true, color: "default", checkedIcon: react_1.default.createElement("span", { className: clsx_1.default(classes.icon, classes.checkedIcon) }), icon: react_1.default.createElement("span", { className: classes.icon }), inputProps: { "aria-label": "decorative checkbox" } }, props)));
}
exports.CheckboxWrap = CheckboxWrap;
//# sourceMappingURL=CheckoxWrap.js.map